module.exports = __webpack_public_path__ + "static/media/warning.5cfea2f4.svg";